import StockOpnamePlan from '@/models/StockOpnamePlan/StockOpnamePlan';

export default class StockOpnamePlanFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.name = '';
		this.startStockOpnamePeriodFrom = '';
		this.startStockOpnamePeriodTo = '';
		this.finishStockOpnamePeriodFrom = '';
		this.finishStockOpnamePeriodTo = '';
		this.stockOpnameStatusId  = '';
		this.stockOpnameStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			name : '0',
			startStockOpnamePeriodFrom : '0',
			startStockOpnamePeriodTo : '0',
			finishStockOpnamePeriodFrom : '0',
			finishStockOpnamePeriodTo : '0',
			stockOpnameStatusId : '0',
			stockOpnameStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}